import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageShell from './LegalPageShell';
import { LEGAL_CONTROLLER } from './legalConfig';

/**
 * Terms of Service — professional OSINT use; draft for counsel review.
 */
export default function TermsOfService() {
  const c = LEGAL_CONTROLLER;

  return (
    <LegalPageShell title="Terms of Service" path="/terms">
      <p>
        These Terms govern access to <strong>{c.productName}</strong>, an OSINT investigation
        workspace for professional digital due diligence at <strong>{c.siteUrl}</strong>. By using
        the service you agree to these Terms.
      </p>

      <h2>1. Intended audience</h2>
      <p>CyberTracer is intended for:</p>
      <ul>
        <li>Companies and corporate security / compliance teams</li>
        <li>Legal professionals and counsel supporting due diligence</li>
        <li>Risk, fraud, and AML analysts</li>
        <li>Authorized investigators acting within lawful mandates</li>
      </ul>

      <h2>2. Acceptable use</h2>
      <p>
        You may use CyberTracer only for lawful professional purposes, including corporate due
        diligence, B2B anti-fraud checks, cyber risk assessment, and sanctions awareness based on
        public sources. You represent that you have a valid legal basis to process any personal data
        you submit or obtain through the workspace.
      </p>

      <h2>3. Prohibited use</h2>
      <p>You must not use CyberTracer for:</p>
      <ul>
        <li>Harassment, stalking, doxxing, or intimidation of individuals</li>
        <li>Illegal surveillance or unauthorized access to systems or accounts</li>
        <li>Any activity that violates criminal, civil, or data-protection law</li>
        <li>Attempting to retrieve, traffic, or store stolen credentials or illicit dumps</li>
        <li>Processing children’s data without a clear lawful basis and necessity</li>
      </ul>

      <h2>4. Nature of results</h2>
      <p>
        Results are OSINT-derived and may be incomplete, outdated, or false-positive. Human review
        remains mandatory. CyberTracer does not provide legal advice, credit decisions, or
        guaranteed identity resolution.
      </p>

      <h2>5. Customer responsibility (B2B)</h2>
      <p>
        Where your organisation uses CyberTracer for investigations, your organisation is
        responsible for mandates, internal policies, and lawful instructions to investigators.
        CyberTracer may act as a tool provider / processor under a separate data processing
        agreement when counsel so structures the relationship.
      </p>

      <h2>6. Privacy and cookies</h2>
      <p>
        Personal data processing is described in our <Link to="/privacy">Privacy Policy</Link>.
        Cookie and local storage practices are described in our{' '}
        <Link to="/cookies">Cookie Policy</Link>.
      </p>

      <h2>7. Intellectual property and reports</h2>
      <p>
        Exported PDF/CSV reports are generated for your professional use. You remain responsible for
        how you store and share downloads outside CyberTracer.
      </p>

      <h2>8. Availability and limitation of liability</h2>
      <p>
        The service is provided on an “as available” basis. To the extent permitted by law, we are
        not liable for decisions taken solely on automated or incomplete OSINT output.
      </p>

      <h2>9. Contact</h2>
      <p>
        Support:{' '}
        <a href={`mailto:${c.email}`}>{c.email}</a>
      </p>
    </LegalPageShell>
  );
}
